import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { selectProcedureTypeById } from "@overmap-ai/core"
import { getRouteApi, Link } from "@tanstack/react-router"
import { memo } from "react"

import { ProcedureTypeIcon } from "../../components/Icons/ProcedureTypeIcon"
import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { BaseTopBar } from "../TopBars/BaseTopBar"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/")

export const ProcedureTypeSettingsStepsViewTopBar = memo(() => {
	const { procedureTypeId } = routeApi.useParams()

	const procedureType = useAppSelector(selectProcedureTypeById(procedureTypeId))!
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/procedure-types/$procedureTypeId/steps/"
					to="/$organizationId/settings/procedure-types/$procedureTypeId"
				>
					<Button>
						<LuIcon icon={modelIconMapping.arrowLeft} />
						<ProcedureTypeIcon procedureTypeId={procedureTypeId} />
						<Text className="truncate">{procedureType.name}</Text>
					</Button>
				</Link>
			}
		/>
	)
})
ProcedureTypeSettingsStepsViewTopBar.displayName = "ProcedureTypeSettingsStepsViewTopBar"
